import {Logger} from "platform/logger/Logger";
import {IDpkHandler} from "platform/dpk/Dpk";
import {TSMap} from "typescript-map";
import {DpkType} from "enum/DpkType";
import Utils from "platform/util/Utils";
import Platform from "platform/Platform";
import {GoingOpenDeal} from "core/redux/deal/DealReduxActions";
import {DpkParam} from "enum/DpkParam";
import {PositionDirection} from "platform/protocol/enum/PositionDirection";
import {StoreState} from "core/redux/StoreState";
import {DoRegisterUserActivity, OnProcessTopUpButton} from "core/redux/account/AccountReduxActions";
import Parameter from "platform/util/Parameter";
import {TradeSymbol} from "platform/protocol/trading/symbol/TradeSymbol";
import {SetTradingModal} from "core/redux/app/AppReduxActions";
import TradingModalType from "enum/TradingModalType";
import {AccountOption} from "protocol/account/AccountOption";
import {TradingModalUserFeedback} from "core/redux/app/AppReduxState";
import {BIEventType} from "enum/BIEventType";
import {ShowChat} from "platform/redux/core/CoreActions";
import {UserActivityType} from "enum/UserActivityType";

export class DpkHandler implements IDpkHandler<DpkType> {

    protected _logger: Logger = Logger.Of(this.constructor.toString().match(/\w+/g)[1]);

    public dpkTypes(): DpkType[] {
        return [
            DpkType.OpenPosition,
            DpkType.openposition,
            DpkType.OpenDeposit,
            DpkType.Deposit,
            DpkType.OpenUploadDocument,
            DpkType.UserFeedback,
            DpkType.StartChat,
            DpkType.RegisterActivity
        ];
    }

    public handle(dpkType: DpkType, parameters: TSMap<string, any>, params: Parameter[], action?: (routeType?: string, params?: Parameter[]) => void): void {
        if (Utils.isNotNull(dpkType)) {
            switch (dpkType) {
                case DpkType.OpenPosition:
                    const SymbolId: number = parseInt(parameters.get(DpkParam.SymbolId), 10);
                    const Direction: PositionDirection = parseInt(parameters.get(DpkParam.Direction), 10);
                    const stopLoss: number = parseFloat(parameters.get(DpkParam.StopLoss));
                    const takeProfit: number = parseFloat(parameters.get(DpkParam.TakeProfit));
                    this._logger.debug("Open position. SymbolId: " + SymbolId + " Direction: " + Direction);
                    if (SymbolId && Direction) {
                        const {symbols} = Platform.reduxState<StoreState>().symbols;
                        if (symbols.has(SymbolId)) {
                            Platform.dispatch(GoingOpenDeal({
                                SymbolId,
                                Direction,
                                stopLoss,
                                takeProfit,
                                action
                            }));
                            Platform.bi().track(BIEventType.DeepLinkOpenPosition, {
                                SymbolName: symbols.get(SymbolId).text
                            });
                        }
                    }
                    break;
                case DpkType.openposition:
                    const ric: string = parameters.get(DpkParam.Ric) || Parameter.value(DpkParam.Ric, params);
                    const direction: string = parameters.get(DpkParam.direction) || Parameter.value(DpkParam.direction, params);
                    const sl: string = parameters.get(DpkParam.StopLoss) || Parameter.value(DpkParam.StopLoss, params);
                    const tp: string = parameters.get(DpkParam.TakeProfit) || Parameter.value(DpkParam.TakeProfit, params);
                    this._logger.debug("RIC: " + ric + " Dir: " + direction + " SL: " + sl + " TP: " + tp)
                    if (ric) {
                        const {symbols} = Platform.reduxState<StoreState>().symbols;
                        for (let i = 0; i < symbols.size(); i++) {
                            const symbol: TradeSymbol = symbols.values()[i];
                            if (symbol?.tradingCentralRICCode === ric) {
                                const positionDirection: PositionDirection = direction === "buy" ? PositionDirection.Buy : PositionDirection.Sell;
                                Platform.dispatch(GoingOpenDeal({
                                    SymbolId: symbol.SymbolId,
                                    Direction: positionDirection,
                                    stopLoss: parseFloat(sl),
                                    takeProfit: parseFloat(tp),
                                    action
                                }));
                                Platform.bi().track(BIEventType.DeepLinkOpenPosition, {
                                    SymbolName: symbol.text
                                });
                                break;
                            }
                        }
                    }
                    break;
                case DpkType.OpenDeposit:
                case DpkType.Deposit:
                    Platform.dispatch(OnProcessTopUpButton({
                        parameters: params,
                        action
                    }));
                    break;
                case DpkType.OpenUploadDocument:
                    const {ShownMenuItems} = Platform.reduxState<StoreState>().account;
                    if ((ShownMenuItems & AccountOption.DocumentUploader) > 0) {
                        if (action) {
                            action();
                        } else {
                            Platform.dispatch(SetTradingModal({
                                tradingModalType: TradingModalType.Documents,
                                info: {
                                    visible: true
                                }
                            }));
                        }
                    }
                    break;
                case DpkType.UserFeedback:
                    if (action) {
                        action(null, params);
                    } else {
                        const fParams: TradingModalUserFeedback = {fromDpk: true};
                        Platform.dispatch(SetTradingModal({
                            tradingModalType: TradingModalType.Feedback,
                            info: {
                                visible: true,
                                params: fParams
                            }
                        }));
                    }
                    break;
                case DpkType.StartChat:
                    if (action) {
                        action();
                    } else {
                        Platform.dispatch(ShowChat({
                            opposite: true,
                            comment: "Executed by deep link"
                        }));
                    }
                    break;
                case DpkType.RegisterActivity:
                    const activity: UserActivityType = parseInt(parameters.get(DpkParam.Activity), 10);
                    if (activity === UserActivityType.HelpRequested) {
                        const {CallMeEnabled} = Platform.reduxState<StoreState>().settings;
                        if (CallMeEnabled) {
                            Platform.dispatch(DoRegisterUserActivity({
                                userActivity: UserActivityType.HelpRequested
                            }));
                        }
                    }
                    break;
            }
        }
    }
}
